import * as nomes from './mutations.nomes'
import coresPadrao from '@/common/situacoes.cores'
import sessionAgendamentoOnline from "@/common/session.agendamento.online";

export default {
  [nomes.ALTERAR_DATA_ATUAL](state, payload) {
    state.dataAtual = payload;
  },
  [nomes.FILTRAR_CLIENTES](state, payload) {
    state.filtroClientes = payload;
  },
  [nomes.FILTRAR_PROFISSIONAIS](state, payload) {
    state.filtroProfissionais = payload;
  },
  [nomes.FILTRAR_FUNCOES](state, payload) {
    state.filtroFuncoes = payload;
  },
  [nomes.FILTRAR_SERVICOS](state, payload) {
    state.filtroServicos = payload;
  },
  [nomes.ALTERAR_TIPO_AGENDA](state, payload) {
    state.tipoAgenda = payload;
  },
  [nomes.ATUALIZAR_LISTA_PROFISSIONAIS](state, payload) {
    state.listaProfissionais = payload;
  },
  [nomes.ATUALIZAR_LISTA_SERVICOS](estado, payload) {
    estado.listaServicos = payload;
  },
  [nomes.ATUALIZAR_LISTA_FUNCOES](estado, payload) {
    estado.listaFuncoes = payload;
  },
  [nomes.GRAVAR_PARAMETROS](state, payload) {
    state.parametros = payload;
  },
  [nomes.GRAVAR_PARAMETROS_AGENDAMENTO](state, payload) {
    state.sessaoAgendamento.parametros = payload;
  },
  [nomes.LOGIN_AGENDAMENTO](state, payload) {
    state.sessaoAgendamento.sessao = payload
  },
  [nomes.LOGOUT_AGENDAMENTO](state) {
    state.sessaoAgendamento.sessao = null;
  },
  [nomes.ATUALIZAR_CONFIGURACAO](state, payload) {
    state.parametros.configuracoes = payload;
    state.coresAgenda = (payload && payload.cores ? payload.cores : null) || Object.assign({}, coresPadrao);
    state.funcaoCoresItems = (payload && payload.funcaoCoresItems ? payload.funcaoCoresItems : {});
  },
  [nomes.INICIALIZAR_CONFIGURACAO_CORES](state, payload) {    
    state.parametros = payload;
    state.parametros.configuracoes = {};    
    state.parametros.configuracoes.cores = (payload && payload.cores ? payload.cores : null) || Object.assign({}, coresPadrao);
  },
  [nomes.ATUALIZAR_CONFIGURACAO_FUNCAO](state, payload) {
    state.funcaoCoresItems = payload;
  },
  [nomes.EXIBIR_ERRO](state, payload) {
    state.erro = payload;
  },
  [nomes.AUTENTICACAO_MICROVIX_AGENDAMENTO_ONLINE](state, payload) {
    state.autenticacaoMicrovixAgendamentoOnline = payload;
  },
  [nomes.LIMPAR_AUTENTICACAO_MICROVIX_AGENDAMENTO_ONLINE](state) {
    state.autenticacaoMicrovixAgendamentoOnline = { autenticado: false, alias: null };
  },
  [nomes.AUTENTICACAO_MICROVIX_AGENDA](state, payload) {
    state.autenticacaoMicrovixAgenda = payload;
  },
  [nomes.LIMPAR_AUTENTICACAO_MICROVIX_AGENDA](state) {
    state.autenticacaoMicrovixAgenda = { autenticado: false };
  },
  [nomes.LOGIN_AGENDAMENTO_ONLINE](state, payload) {
    state.sessaoAgendamentoOnline = payload;
  },
  [nomes.LOGOUT_AGENDAMENTO_ONLINE](state) {
    sessionAgendamentoOnline.setSessaoAgendamentoOnline(null);
    state.sessaoAgendamentoOnline = {autenticado: false, parametros: null, sessao: null };
  },
  [nomes.GRAVAR_CONFIG_VISUAL_AGENDAMENTO_ONLINE](state, payload) {
    state.configVisualAgendamentoOnline = payload;
  },
};
